import Parent from "parentjs/controllers/accordion_controller.js";
export default Parent;
